import Vue from 'vue'
import VueRouter from 'vue-router'
import NotFound from "@/views/Global/NotFound";

Vue.use(VueRouter)

const routes = [
    /*{ 
      path: '/',
      redirect: 'NotFound'
    },*/
    /*{
        path: '/:corpId(\\d+)',
        redirect: ':corpId(\\d+)/Home'
    },

    {
        path: '/:corpId/Home',
        name: 'Home',
        meta: {
            title: '首页'
        },
        component: () => import('@/views/Home/Index.vue')
    },

    {
        path: '/:corpId/SetUp',
        name: 'Specification',
        meta: {
            title: '项目规格'
        },
        component: () => import('@/views/SetUp/Specification.vue')
    },
    {
        path: '/:corpId/GoodsCate',
        name: 'GoodsCate',
        meta: {
            title: '商品分类'
        },
        component: () => import('@/views/GoodsCate/Index.vue')
    },
    {
        path: '/:corpId/SpecificationSetting',
        name: 'SpecificationSetting',
        meta: {
            title: '规格设置'
        },
        component: () => import('@/views/SpecificationSetting/Index.vue')
    },
    {
        path: '/:corpId/GoodsSetting',
        name: 'GoodsSetting',
        meta: {
            title: '商品设置'
        },
        component: () => import('@/views/GoodsSetting/Index.vue')
    },
    

    {
        path: '/:corpId(\\d+)/NotFound',
        name: 'NotFound',
        component: NotFound
    },
    {
        path: "/:corpId(\\d+)/!*", // 此处需特别注意置于最底部
        redirect: "/:corpId(\\d+)/NotFound"
    }*/
]

const router = new VueRouter({
    mode: 'history',
    // base: process.env.BASE_URL,
    base: import.meta.env.BASE_URL,
    routes
})

export default router
